interface FaqSidebarProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function FaqSidebar({
  categories,
  selectedCategory,
  onCategoryChange,
}: FaqSidebarProps) {
  const categoryIcons: Record<string, string> = {
    all: 'ri-list-check',
    buying: 'ri-shopping-cart-line',
    financing: 'ri-money-dollar-circle-line',
    'trade-in': 'ri-exchange-line',
    warranty: 'ri-shield-check-line',
    delivery: 'ri-truck-line',
    general: 'ri-question-line',
  };

  const formatCategory = (cat: string) => {
    if (cat === 'all') return 'All Questions';
    return cat
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E2D6] p-6 sticky top-24">
      <h3 className="font-['Oswald'] text-xl font-bold text-[#1C2B1E] mb-4">
        Categories
      </h3>
      <nav aria-label="FAQ categories" className="space-y-2">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            aria-current={selectedCategory === category ? 'true' : undefined}
            className={`w-full text-left px-4 py-3 rounded-lg transition-colors flex items-center gap-3 cursor-pointer ${
              selectedCategory === category
                ? 'bg-[#1C2B1E] text-white'
                : 'text-[#374151] hover:bg-[#F7F5F0]'
            }`}
          >
            <i
              className={`${categoryIcons[category] || 'ri-folder-line'} text-lg`}
              aria-hidden="true"
              style={{
                color: selectedCategory === category ? '#E8B84B' : '#4A5568',
              }}
            ></i>
            <span className="font-medium">{formatCategory(category)}</span>
          </button>
        ))}
      </nav>

      {/* Contact CTA */}
      <div className="mt-6 pt-6 border-t border-[#E8E2D6]">
        <p className="text-sm text-[#374151] mb-3">Still have questions?</p>
        <a
          href="/contact"
          className="w-full px-4 py-3 bg-[#E8B84B] text-[#1C2B1E] rounded-lg font-medium hover:bg-[#d4a43d] transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-message-3-line" aria-hidden="true"></i>
          Contact Us
        </a>
      </div>
    </div>
  );
}
